import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

    connect() {
        this.preventBackgroundScroll();
        this.createEnableScrollingObservers();
        this.change_landing_page_navigation();
        this.updateNavActiveListener();
        this.disablePhase1Links();
    }

    preventBackgroundScroll = () => {
        if (document.location.search.match(/open_modal=true/)) {
            this.prevent_background_scroll('#page-modal');
        }
        if (document.location.search.match(/from_landing_page=true/)) {
            this.prevent_background_scroll('#landing-page-modal');
        }
        const controller = this
        document.querySelectorAll('.sl-cta-btn').forEach(element =>
            element.addEventListener('click', function (_) {
                    controller.prevent_background_scroll('#page-modal');
                    controller.prevent_background_scroll('#landing-page-modal');
                }
            ));
    }

    createEnableScrollingObservers = () => {
        const controller = this;
        const modals = [
            "landing-page-contact-modal",
            "page-modal",
            "landing-page-modal",
            "landing-page-modal-blur"
        ]
        const observerOptions = {attributes: true, attributeFilter: ['style'], subtree: true};
        const observer = new MutationObserver((mutations) => {

            const hideMutation = mutations.length > 0
                && typeof mutations[0].target.style === 'object'
                && mutations[0].target.style.display === 'none'

            if (mutations.length > 0 && typeof mutations[0].target === 'object') {
                const target_modal = mutations[0].target.id
                if (modals.includes(target_modal) && hideMutation && document.body.style.position === 'fixed') {
                    controller.enableScrolling(0);
                }
            }
        });

        modals
            .map(modal => document.getElementById(modal))
            .filter(x => x !== null && typeof x !== 'undefined')
            .forEach(modalElem => observer.observe(modalElem, observerOptions));
    }

    updateNavActiveListener = () => {
        if (document.location.href.match(/my\/users\/sign_/)) {
            document.addEventListener('DOMContentLoaded', _ => {
                document.querySelectorAll('.sl-nav-item')
                    .forEach(el => el.addEventListener("click", (e) => this.updateNavActive($(e.target).attr('href'))));

                this.updateNavActive(window.location.href);
            });
        }
    }

    disablePhase1Links = () => {
        // =====================================================
        // === DEPRECATED: add detail pages for "Angebot", …
        // === and remove this code
        // =====================================================
        document.querySelectorAll('.phase1')
            .forEach(el => el.addEventListener("click", (e) => {
                if ($(e.target).hasClass("phase1") || typeof ($(e.target).attr('href')) == "undefined") {
                    e.preventDefault()
                }
            }));
    }

    change_landing_page_navigation() {
        document.querySelectorAll('a.sl-nav-item').forEach(e => {
            const href = e.getAttribute("href");
            if (href.startsWith("#")) {
                e.setAttribute("href", `/my/users/sign_in${href}`)
            }
        })
    }

    prevent_background_scroll(modal_selector) {
        const header = document.querySelector("header");
        const scrollY = parseInt($(window).scrollTop());

        document.body.style.position = 'fixed'
        header.style.position = 'fixed'
        header.style.width = '100vw'
        document.body.style.paddingTop = `${header.offsetHeight}px`
        document.body.style.top = `-${scrollY}px`

        M.Modal.init(document.querySelectorAll(modal_selector), {
            onCloseStart: () => this.enableScrolling(scrollY)
        })
    }

    enableScrolling(scrollY) {
        document.body.style.position = ''
        document.body.style.top = ''
        document.body.style.paddingTop = ''

        const header = document.querySelector("header");
        if (typeof header === 'object') {
            header.style.position = ''
            header.style.width = ''
        }

        $(window).scrollTop(scrollY)
    }

    updateNavActive(target) {
        let el = $('.sl-nav-item')
        el.removeClass('sl-nav-item--active')
        el.removeAttr('tabindex')

        let anchor = target.split("#")[1]
        if (typeof (anchor) != "undefined" && anchor.match(/[a-zA-Z_]/)) try {
            el = $(`#nav-${anchor}`)
            el.addClass('sl-nav-item--active')
            el.attr('tabindex', -1)
        } catch (Error) {
        }
    }
}